<div class="currency-selector">
    <ng-select [items]="dropdownItems" [multiple]="true" [loading]="loading" [disabled]="disabled" bindValue="id"
        [ngModel]="selectedIds" (ngModelChange)="onSelectionChange($event)" placeholder="Seleccionar límites...">
        <ng-template ng-label-tmp let-item="item">
            {{ item.currency }}
            <span style="color: #6c757d; font-size: 0.9em;">
                ({{ item.min | number }} - {{ item.max | number }})
            </span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-item$="item$">
            <span [class.text-muted]="!canSelectCurrency(item)">
                {{ item.currency }}
                <span class="text-muted ms-1" style="font-size: 0.9em;">
                    ({{ item.min | number }} - {{ item.max | number }})
                </span>
            </span>
        </ng-template>
    </ng-select>

    <!-- Status info -->
    <div class="mt-2 small" *ngIf="selectedIds.length > 0">
        <span class="text-muted">
            <span *ngIf="hasDop" class="badge bg-success me-1">DOP ✓</span>
            <span *ngIf="hasUsd" class="badge bg-primary me-1">USD ✓</span>
            <span *ngIf="isLimitReached" class="text-success ms-1">
                (Límites definidos)
            </span>
        </span>
    </div>

    <div class="mt-2">
        <button type="button" class="btn btn-sm btn-outline-colonial" (click)="toggleCreateForm()"
            [disabled]="disabled || !canAddMore">
            <span class="material-symbols-outlined" style="font-size: 16px; vertical-align: middle;">add</span>
            {{ showCreateForm ? 'Cancelar' : 'Crear nuevo límite' }}
        </button>
        <small *ngIf="!canAddMore && !showCreateForm" class="text-muted ms-2">
            (Máx. 1 configuración por moneda)
        </small>
    </div>

    <div class="create-form card mt-2" *ngIf="showCreateForm">
        <div class="card-body">
            <h6 class="card-title">Nuevo Límite</h6>
            <form [formGroup]="createForm" (ngSubmit)="saveNewCurrency()">
                <div class="row g-2">
                    <div class="col-12 col-md-4">
                        <label class="form-label">Moneda *</label>
                        <select class="form-select form-select-sm" formControlName="currency">
                            <option *ngFor="let opt of availableCurrencyOptions" [value]="opt.value">{{ opt.label }}
                            </option>
                        </select>
                    </div>
                    <div class="col-6 col-md-4">
                        <label class="form-label">Mínimo *</label>
                        <input type="text" class="form-control form-control-sm" formControlName="min" mask="separator.2"
                            thousandSeparator="," />
                    </div>
                    <div class="col-6 col-md-4">
                        <label class="form-label">Máximo *</label>
                        <input type="text" class="form-control form-control-sm" formControlName="max" mask="separator.2"
                            thousandSeparator="," />
                    </div>
                </div>
                <div class="d-flex justify-content-end gap-2 mt-3">
                    <button type="button" class="btn btn-sm btn-outline-secondary"
                        (click)="toggleCreateForm()">Cancelar</button>
                    <button type="submit" class="btn btn-sm btn-colonial" [disabled]="createForm.invalid || loading">
                        Guardar
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>